<div class="mylibrary_page">
    <ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>
    <ngx-spinner type="ball-scale-multiple" size="medium" [name]="programLoader"></ngx-spinner>
    <app-header [headerTitle]="headerTitle"></app-header>
    <div class="mylibraryHeader breadCrumb">
        <div>
            <img (click)="goBack()" src="../../assets/images/backarrlibrary.svg" alt=""> <span class="learning">Learning
                Centre ></span> <span class="library">Library</span>
        </div>
        <div *ngIf="user" class="profile">
            <img [routerLink]="'/profile-page'" *ngIf="!user?.userPic" src="assets/images/user (1).png" alt="" class="profile_image">
            <img [routerLink]="'/profile-page'" *ngIf="user?.userPic" [src]="user?.userPic" alt="" class="profile_image">
            <div>{{user?.name}}</div>
        </div>
    </div>

    <div class="mobileMenu">

        <div *ngIf="activePrograms.length === 0 && showPopup" class="no_prog_popup">
            <div class="no_prog_popuc_container">
                <h2>You have no active programs</h2>

                <div class="sad_emoji">
                    <img src="../../assets/images/sad.png" alt="">
                </div>

                <div class="letsGo" (click)="hidePopup()">
                    Let's Go <img src="../../assets/images/dashboard_images/Arrow - Right.png" alt="">
                </div>
            </div>
        </div>

        <div class="breadCrumb">
            <div>
                <img (click)="goBack()" src="../../assets/images/backarrlibrary.svg" alt=""> <span class="learning">Learning
                    Centre ></span> <span class="library">Library</span>
            </div>
            <div *ngIf="user" class="profile">
                <img [routerLink]="'/profile-page'" *ngIf="!user?.userPic" src="assets/images/user (1).png" alt="" class="profile_image">
                <img [routerLink]="'/profile-page'" *ngIf="user?.userPic" [src]="user?.userPic" alt="" class="profile_image">
                <!-- <div>{{user?.name}}</div> -->
            </div>
        </div>

        <div class="mobileHeader">
            <div class="selectedTabname">
				<span *ngIf="selectedCatName && selectedCatName.length >= 1">{{selectedCatName}}</span>
				<span *ngIf="selectedsubcatName && selectedsubcatName.length >= 1"> - {{selectedsubcatName}}</span>
			</div>
            <button class="openClosesidemanu" (click)="toggleSidenav()"><img src="../../assets/images/open-menu (1).svg"
                    alt=""></button>
        </div>

        <mat-sidenav-container>
            <mat-sidenav #sidenav mode="side" position="end">
                <div class="sidemenuOpacity" (click)="toggleSidenav()">
                    <div class="crossBtn">
                        <button style="padding: 8px 12px; background-color: rgb(97,141,126) !important;"
                            class="openClosesidemanu"><img
                                src="../../assets/images/sidenavcrossBtn.svg" alt=""></button>
                    </div>
                </div>

                <div class="main_categ">

                    <div class="categ_row" (click)="showSubcategForAll($event)">
                        <span> All</span>
                    </div>

                    <div class="mainCategClass" *ngFor="let cat of categories; let i = index">
                        <ng-container>
                            <div class="categ_row">
                                <span (click)="showSubcateg(cat)"> {{cat.name}}</span>
								<span>
									<img (click)="showSubcateg(cat)" src="../../../../../assets/images/plusIcon.svg" alt="" *ngIf="!cat.showSubCategories">
									<span (click)="showSubcateg(cat)" *ngIf="cat.showSubCategories" class="minus-icon">&#x2212;</span>
								</span>
                            </div>

                            <div class="subcategDropdown" *ngIf="cat.showSubCategories">
								<div class="subcateg" tabindex="1" (click)="onSelectSubCategInMobile('All', cat.id, {}, cat.name, i, -1)" *ngIf="cat.subCategories.length >= 1">
									<span class="hifen">-</span>
									All
								</div>
                                <div *ngFor="let subcateg of cat.subCategories; let j = index">
									<div *ngIf="subcateg.visible">
										<div class="subcateg" tabindex="1" (click)="onSelectSubCategInMobile(subcateg.name, cat.id, subcateg, cat.name, i, j)">
											<span class="hifen">-</span>
											{{subcateg.name}}
										</div>
									</div>
                                </div>
                            </div>
                        </ng-container>

                    </div>

                    <!-- <div (click)="applySubcategories()" class="applyBtn">
                        APPLY
                    </div> -->
                </div>

            </mat-sidenav>

            <mat-sidenav-content>
                <!-- <ng-container *ngIf="subcateg.visible">
                    <mdb-tab [title]="subcateg?.name"> -->
                <div class="myPrograms">
                    <div class="programs_opacity"></div>
                    <div style="margin-bottom: 27px; z-index: 100;">
                        <div class="carousell" *ngIf="currentPrograms?.length >= 1 && !showallsubcat">
                            <ng-container *ngFor="let subProgram of currentPrograms; let i = index">
                                <div class="card_container" *ngIf="subProgram.isPublished !== false">
                                    <div #cardEl id="cardEl" class="image_div"><img class="card_image2"
                                            [src]="subProgram?.programImage"></div>
                                    <div class="card_content_container">
                                        <div class="card_content_row">
                                            <div *ngIf="subProgram.isUserEnrolled" class="cursor-pointer"
                                                (click)="launchProgramByCardAfterCheck(subProgram)">
                                                <div class="completed" *ngIf="subProgram.progress === 100">Completed
                                                </div>
                                                <div class="inprogress" *ngIf="subProgram.progress !== 100">In Progress
                                                </div>
                                            </div>
                                            <div class="noprogress cursor-pointer" *ngIf="!subProgram.isUserEnrolled"
                                                (click)="launchProgramByCardAfterCheck(subProgram)">Not Yet Started
                                            </div>

                                            <div class="card_footer_sub_head">
                                                {{ subProgram.courseTime | duration }}
                                            </div>

                                            <div (click)="changeState(subProgram)" class="full_screen_icon"><img
                                                    src="../../../../../assets/images/inspect_icon.png" alt="">
                                            </div>
                                        </div>

                                        <h2 class="hire_inspire">{{subProgram.name}}

                                        </h2>
                                        <p class="card_para_container">
                                            {{subProgram.description}}
                                        </p>

                                        <div class="card_footer">
                                            <div class="footer_column dNone">
                                                <div class="card_footerIcn">
                                                    <img src="../../assets/images/Time Circle.svg" alt="">
                                                </div>
                                                <div class="card_footer_sub_head">
                                                    {{ subProgram.courseTime | duration }}
                                                </div>
                                            </div>

                                            <div class="footer_column dNone">
                                                <div class="card_footerIcn">
                                                    <img src="../../assets/images/Category.svg" alt="">
                                                </div>
                                                <div class="card_footer_sub_head">
                                                    {{ getSectionNos(programSections) }} Sections
                                                </div>
                                            </div>

                                            <div class="footer_column">
                                                <div class="launchBtn">
                                                    Launch <img style="margin-left: 4px"
                                                        src="../../assets/images/Arrow - Right.svg" alt="">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <div class="horizontalLine" *ngIf="currentNotAllowedPrograms?.length >= 1">

                        </div>
                        <div class="NA" *ngIf="currentNotAllowedPrograms?.length >= 1">
                            <p>Access Unavailable</p>
                        </div>

                        <div class="carousell" *ngIf="currentNotAllowedPrograms?.length >= 1">
                            <ng-container *ngFor="let subProgram of currentNotAllowedPrograms">
                                <div class="card_container" *ngIf="subProgram.isPublished !== false">
                                    <div #cardEl id="cardEl" class="image_div"><img class="card_image2"
                                            [src]="subProgram?.programImage"></div>
                                    <div class="card_content_container">
                                        <div class="card_content_row">
                                            <div *ngIf="subProgram.isUserEnrolled" class="cursor-pointer"
                                                (click)="launchProgramByCardAfterCheck(subProgram)">
                                                <div class="completed" *ngIf="subProgram.progress === 100">Completed
                                                </div>
                                                <div class="inprogress" *ngIf="subProgram.progress !== 100">In Progress
                                                </div>
                                            </div>
                                            <div class="noprogress cursor-pointer" *ngIf="!subProgram.isUserEnrolled"
                                                (click)="launchProgramByCardAfterCheck(subProgram)">Not Yet Started
                                            </div>

                                            <div class="card_footer_sub_head">
                                                {{ subProgram.courseTime | duration }}
                                            </div>

                                            <div (click)="changeState(subProgram)" class="full_screen_icon"><img
                                                    src="../../../../../assets/images/inspect_icon.png" alt="">
                                            </div>
                                        </div>

                                        <h2 class="hire_inspire">{{subProgram.name}}</h2>
                                        <p class="card_para_container">
                                            {{subProgram.description}}
                                        </p>
                                        <!-- <button class="letsGoBtn" *ngIf="!subProgram.isRegistered"
                                            (click)="onClickRegister(subProgram.id)">Register Interest</button>
                                        <button class="letsGoBtn interested" *ngIf="subProgram.isRegistered">Interested</button> -->


                                        <div class="card_footer">
                                            <div class="footer_column dNone">
                                                <div class="card_footerIcn">
                                                    <img src="../../assets/images/Time Circle.svg" alt="">
                                                </div>
                                                <div class="card_footer_sub_head">
                                                    {{ subProgram.courseTime | duration }}
                                                </div>
                                            </div>

                                            <div class="footer_column dNone">
                                                <div class="card_footerIcn">
                                                    <img src="../../assets/images/Category.svg" alt="">
                                                </div>
                                                <div class="card_footer_sub_head">
                                                    {{ getSectionNos(programSections) }} Sections
                                                </div>
                                            </div>

                                            <div class="footer_column">
                                                <div class="launchBtn">
                                                    Launch <img style="margin-left: 4px"
                                                        src="../../assets/images/Arrow - Right.svg" alt="">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        <div *ngIf="showallsubcat">
                            <div style="margin-bottom: 27px; z-index: 100;">
                                <div class="carousell" style="padding: 30px 0px" *ngIf="currentPrograms?.length >= 1 && !initialLoad">
                                    <div [ngClass]="{ 'card_container': program?.programImage && program?.name, 'display_contents': !program?.programImage || !program?.name}"
                                        class="" *ngFor="let program of currentPrograms">
                                        <ng-container *ngIf="program.programImage && program.isPublished !== false">
                                            <div class="image_div"><img #cardElement id="cardElement" class="card_image"

                                                    [src]="program?.programImage" alt="Program Image"></div>
                                            <div class="card_content_container">
                                                <div class="card_content_row">
                                                    <div *ngIf="program.isUserEnrolled"
                                                        (click)="launchProgramByCardAfterCheck(program)"
                                                        class="cursor-pointer">
                                                        <div class="completed" *ngIf="program.progress === 100">
                                                            Completed</div>
                                                        <div class="inprogress" *ngIf="program.progress !== 100">In
                                                            Progress</div>
                                                    </div>
                                                    <div class="noprogress cursor-pointer"
                                                        *ngIf="!program.isUserEnrolled"
                                                        (click)="launchProgramByCardAfterCheck(program)">Not yet
                                                        Started</div>

                                                    <div class="card_footer_sub_head">
                                                        {{ program.courseTime | duration }}
                                                    </div>

                                                    <div (click)="changeState(program)" class="full_screen_icon"><img
                                                            src="../../../../../assets/images/inspect_icon.png" alt="">
                                                    </div>
                                                </div>

                                                <h2 class="hire_inspire">{{program?.name}}</h2>
                                                <p class="card_para_container">
                                                    {{program?.description}}
                                                </p>

                                                <div class="card_footer">
                                                    <div class="footer_column dNone">
                                                        <div class="card_footerIcn">
                                                            <img src="../../assets/images/Time Circle.svg" alt="">
                                                        </div>
                                                        <div class="card_footer_sub_head">
                                                            {{ program.courseTime | duration }}
                                                        </div>
                                                    </div>

                                                    <div class="footer_column dNone">
                                                        <div class="card_footerIcn">
                                                            <img src="../../assets/images/Category.svg" alt="">
                                                        </div>
                                                        <div class="card_footer_sub_head">
                                                            {{ getSectionNos(programSections) }} Sections
                                                        </div>
                                                    </div>

                                                    <div class="footer_column">
                                                        <div class="launchBtn">
                                                            Launch <img style="margin-left: 4px"
                                                                src="../../assets/images/Arrow - Right.svg" alt="">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>

                                <div class="horizontalLine" *ngIf="notAllowedPrograms?.length && !initialLoad">
                                </div>
                                <div class="NA" *ngIf="notAllowedPrograms?.length && !initialLoad">
                                    <p>Access Unavailable</p>
                                </div>

                                <div class="carousell" style="padding: 30px 0px"
                                    *ngIf="notAllowedPrograms?.length && !initialLoad">
                                    <ng-container *ngFor="let program of notAllowedPrograms">

                                        <div *ngIf="program.programImage && program.isPublished !== false"
                                            [ngClass]="{ 'card_container': program?.programImage && program?.name, 'display_contents': !program?.programImage || !program?.name}"
                                            class="">
                                            <div class="image_div"><img #cardElement id="cardElement" class="card_image"

                                                    [src]="program?.programImage" alt="Program Image"></div>
                                            <div class="card_content_container">
                                                <div class="card_content_row">
                                                    <div *ngIf="program.isUserEnrolled"
                                                        (click)="launchProgramByCardAfterCheck(program)"
                                                        class="cursor-pointer">
                                                        <div class="completed" *ngIf="program.progress === 100">
                                                            Completed</div>
                                                        <div class="inprogress" *ngIf="program.progress !== 100">In
                                                            Progress</div>
                                                    </div>
                                                    <div class="noprogress cursor-pointer"
                                                        *ngIf="!program.isUserEnrolled"
                                                        (click)="launchProgramByCardAfterCheck(program)">Not yet
                                                        Started</div>

                                                    <div class="card_footer_sub_head">
                                                        {{ program.courseTime | duration }}
                                                    </div>

                                                    <div (click)="changeState(program)" class="full_screen_icon"><img
                                                            src="../../../../../assets/images/inspect_icon.png" alt="">
                                                    </div>
                                                </div>

                                                <h2 class="hire_inspire">{{program?.name}}</h2>
                                                <span class="programname">{{program?.name}}</span>
                                                <p class="card_para_container">
                                                    {{program?.description}}
                                                </p>
                                                <!-- <button class="letsGoBtn" *ngIf="!program.isRegistered"
                                                    (click)="onClickRegister(program.id)">Register Interest</button>
                                                <button class="letsGoBtn interested"
                                                    *ngIf="program.isRegistered">Interested</button> -->


                                                <div class="card_footer">
                                                    <div class="footer_column dNone">
                                                        <div class="card_footerIcn">
                                                            <img src="../../assets/images/Time Circle.svg" alt="">
                                                        </div>
                                                        <div class="card_footer_sub_head">
                                                            {{ program.courseTime | duration }}
                                                        </div>
                                                    </div>

                                                    <div class="footer_column dNone">
                                                        <div class="card_footerIcn">
                                                            <img src="../../assets/images/Category.svg" alt="">
                                                        </div>
                                                        <div class="card_footer_sub_head">
                                                            {{ getSectionNos(programSections) }} Sections
                                                        </div>
                                                    </div>

                                                    <div class="footer_column">
                                                        <div class="launchBtn">
                                                            Launch <img style="margin-left: 4px"
                                                                src="../../assets/images/Arrow - Right.svg" alt="">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                    </ng-container>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- </mdb-tab>
                </ng-container> -->
            </mat-sidenav-content>
        </mat-sidenav-container>

    </div>

    <mdb-tabs class="desktopMenu" (activeTabChange)="onTabChange($event)" #categoryTabs>
        <mdb-tab title="All">
            <div *ngIf="activePrograms.length === 0 && showPopup" class="no_prog_popup">
                <div class="no_prog_popuc_container">
                    <h2>You have no active programs</h2>

                    <div class="sad_emoji">
                        <img src="../../assets/images/sad.png" alt="">
                    </div>

                    <div class="letsGo" (click)="hidePopup()">
                        Let's Go <img src="../../assets/images/dashboard_images/Arrow - Right.png" alt="">
                    </div>
                </div>
            </div>

            <div style="margin-bottom: 27px; z-index: 100;">
                <div class="carousell" style="padding: 30px" *ngIf="currentPrograms?.length >= 1 && !initialLoad">
                    <ng-container *ngFor="let program of currentPrograms">
                        <div [ngClass]="{ 'card_container': program?.programImage && program?.name, 'display_contents': !program?.programImage || !program?.name}"
                            class="" *ngIf="program.programImage && program.isPublished !== false">
                            <div class="image_div"><img #cardElement id="cardElement" class="card_image"
                                     [src]="program?.programImage"
                                    alt="Program Image"></div>
                            <div class="card_content_container">
                                <div class="card_content_row">
                                    <div *ngIf="program.isUserEnrolled" (click)="launchProgramByCardAfterCheck(program)"
                                        class="cursor-pointer">
                                        <div class="completed" *ngIf="program.progress === 100">Completed</div>
                                        <div class="inprogress" *ngIf="program.progress !== 100">In Progress</div>
                                    </div>
                                    <div class="noprogress cursor-pointer" *ngIf="!program.isUserEnrolled"
                                        (click)="launchProgramByCardAfterCheck(program)">Not Yet Started</div>

                                    <div class="card_footer_sub_head">
                                        {{ program.courseTime | duration }}
                                    </div>

                                    <div (click)="changeState(program)" class="full_screen_icon">
                                        <img src="../../../../../assets/images/inspect_icon.png" alt="">
                                    </div>
                                </div>

                                <h2 class="hire_inspire">{{program?.name}}
                                </h2>

                                <span class="programname">{{program?.name}}</span>

                                <p class="card_para_container">
                                    {{program?.description}}
                                </p>

                                <div class="card_footer">
                                    <div class="footer_column dNone">
                                        <div class="card_footerIcn">
                                            <img src="../../assets/images/Time Circle.svg" alt="">
                                        </div>
                                        <div class="card_footer_sub_head">
                                            {{ program.courseTime | duration }}
                                        </div>
                                    </div>

                                    <div class="footer_column dNone">
                                        <div class="card_footerIcn">
                                            <img src="../../assets/images/Category.svg" alt="">
                                        </div>
                                        <div class="card_footer_sub_head">
                                            {{ getSectionNos(programSections) }} Sections
                                        </div>
                                    </div>

                                    <div class="footer_column">
                                        <div class="launchBtn">
                                            Launch <img style="margin-left: 4px"
                                                src="../../assets/images/Arrow - Right.svg" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                </div>
                <div class="horizontalLine" *ngIf="currentPrograms?.length >= 1 && notAllowedPrograms?.length >= 1 && !initialLoad">
                </div>
                <div class="NA" *ngIf="notAllowedPrograms?.length >= 1 && !initialLoad">
                    <p>Access Unavailable</p>
                </div>
                <div class="carousell" style="padding: 30px" *ngIf="notAllowedPrograms?.length && !initialLoad">
                    <ng-container *ngFor="let program of notAllowedPrograms">
                        <div [ngClass]="{ 'card_container': program?.programImage && program?.name, 'display_contents': !program?.programImage || !program?.name}"
                            class="" *ngIf="program.programImage && program.isPublished !== false">
                            <div class="image_div"><img #cardElement id="cardElement" class="card_image"
                                     [src]="program?.programImage"
                                    alt="Program Image"></div>
                            <div class="card_content_container">
                                <div class="card_content_row">
                                    <div *ngIf="program.isUserEnrolled" (click)="launchProgramByCardAfterCheck(program)"
                                        class="cursor-pointer">
                                        <div class="completed" *ngIf="program.progress === 100">Completed</div>
                                        <div class="inprogress" *ngIf="program.progress !== 100">In Progress</div>
                                    </div>
                                    <div class="noprogress cursor-pointer" *ngIf="!program.isUserEnrolled"
                                        (click)="launchProgramByCardAfterCheck(program)">Not Yet Started</div>


                                    <div class="card_footer_sub_head">
                                        {{ program.courseTime | duration }}
                                    </div>

                                    <div (click)="changeState(program)" class="full_screen_icon"><img
                                            src="../../../../../assets/images/inspect_icon.png" alt="">
                                    </div>
                                </div>

                                <h2 class="hire_inspire">{{program?.name}}</h2>
                                <span class="programname">{{program?.name}}</span>
                                <p class="card_para_container">
                                    {{program?.description}}
                                </p>
                                <!-- <button class="letsGoBtn" *ngIf="!program.isRegistered"
                                    (click)="onClickRegister(program)">Register Interest</button>
                                <button class="letsGoBtn interested" *ngIf="program.isRegistered">Interested</button> -->

                                <div class="card_footer">
                                    <div class="footer_column dNone">
                                        <div class="card_footerIcn">
                                            <img src="../../assets/images/Time Circle.svg" alt="">
                                        </div>
                                        <div class="card_footer_sub_head">
                                            {{ program.courseTime | duration }}
                                        </div>
                                    </div>

                                    <div class="footer_column dNone">
                                        <div class="card_footerIcn">
                                            <img src="../../assets/images/Category.svg" alt="">
                                        </div>
                                        <div class="card_footer_sub_head">
                                            {{ getSectionNos(programSections) }} Sections
                                        </div>
                                    </div>

                                    <div class="footer_column">
                                        <div class="launchBtn">
                                            Launch <img style="margin-left: 4px"
                                                src="../../assets/images/Arrow - Right.svg" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                </div>
            </div>
        </mdb-tab>

        <ng-container *ngFor="let cat of categories">
            <ng-container *ngIf="cat.visible">
                <mdb-tab [title]="cat.name" class="Management">
                    <div class="edit_tabs">
                        <mdb-tabs (activeTabChange)="onSubTabChange($event.tab.title, cat.id)" #subTabs>
							<mdb-tab title="All">
								<ng-template *ngIf="false; else programsDiv">
								</ng-template>
							</mdb-tab>
                            <ng-container *ngFor="let subcateg of cat.subCategories">
                                <ng-container *ngIf="subcateg.visible">
                                    <mdb-tab [title]="subcateg?.name">
										<ng-template *ngIf="false; else programsDiv">
										</ng-template>
                                    </mdb-tab>
                                </ng-container>
                            </ng-container>
                        </mdb-tabs>
                    </div>
                </mdb-tab>
            </ng-container>
        </ng-container>

    </mdb-tabs>
</div>

<ng-template #programsDiv>
	<div class="myPrograms">
		<div class="programs_opacity"></div>
		<div style="margin-bottom: 27px; z-index: 100;">
			<div class="carousell" *ngIf="currentPrograms?.length">
				<ng-container *ngFor="let subProgram of currentPrograms">
					<div class="card_container"
						*ngIf="subProgram.isPublished !== false">
						<div #cardEl id="cardEl" class="image_div"><img
								class="card_image2"
								[src]="subProgram?.programImage">
						</div>
						<div class="card_content_container">
							<div class="card_content_row">
								<div *ngIf="subProgram.isUserEnrolled"
									(click)="launchProgramByCardAfterCheck(subProgram)"
									class="cursor-pointer">
									<div class="completed"
										*ngIf="subProgram.progress === 100">
										Completed
									</div>
									<div class="inprogress"
										*ngIf="subProgram.progress !== 100">In
										Progress
									</div>
								</div>
								<div class="noprogress cursor-pointer"
									*ngIf="!subProgram.isUserEnrolled"
									(click)="launchProgramByCardAfterCheck(subProgram)">
									Not yet
									Started
								</div>

								<div class="card_footer_sub_head">
									{{ subProgram.courseTime | duration }}
								</div>

								<div (click)="changeState(subProgram)"
									class="full_screen_icon"><img
										src="../../../../../assets/images/inspect_icon.png"
										alt="">
								</div>
							</div>

							<h2 class="hire_inspire">{{subProgram.name}}</h2>
							<span class="programname">{{subProgram?.name}}</span>
							<p class="card_para_container">
								{{subProgram.description}}
							</p>

							<div class="card_footer">
								<div class="footer_column dNone">
									<div class="card_footerIcn">
										<img src="../../assets/images/Time Circle.svg"
											alt="">
									</div>
									<div class="card_footer_sub_head">
										{{ subProgram.courseTime | duration }}
									</div>
								</div>

								<div class="footer_column dNone">
									<div class="card_footerIcn">
										<img src="../../assets/images/Category.svg"
											alt="">
									</div>
									<div class="card_footer_sub_head">
										{{ getSectionNos(programSections) }}
										Sections
									</div>
								</div>

								<div class="footer_column">
									<div class="launchBtn">
										Launch <img style="margin-left: 4px"
											src="../../assets/images/Arrow - Right.svg"
											alt="">
									</div>
								</div>
							</div>
						</div>
					</div>
				</ng-container>

			</div>
			<div class="horizontalLine" *ngIf="currentNotAllowedPrograms?.length">

			</div>
			<div class="NA" *ngIf="currentNotAllowedPrograms?.length">
				<p>Access Unavailable</p>
			</div>
			<div class="carousell" *ngIf="currentNotAllowedPrograms?.length">
				<ng-container *ngFor="let subProgram of currentNotAllowedPrograms">
					<div class="card_container"
						*ngIf="subProgram.isPublished !== false">
						<div #cardEl id="cardEl" class="image_div"><img
								class="card_image2"
								[src]="subProgram?.programImage">
						</div>
						<div class="card_content_container">
							<div class="card_content_row">
								<div *ngIf="subProgram.isUserEnrolled"
									(click)="launchProgramByCardAfterCheck(subProgram)"
									class="cursor-pointer">
									<div class="completed"
										*ngIf="subProgram.progress === 100">
										Completed
									</div>
									<div class="inprogress"
										*ngIf="subProgram.progress !== 100">In
										Progress
									</div>
								</div>
								<div class="noprogress cursor-pointer"
									*ngIf="!subProgram.isUserEnrolled"
									(click)="launchProgramByCardAfterCheck(subProgram)">
									Not yet
									Started
								</div>

								<div class="card_footer_sub_head">
									{{ subProgram.courseTime | duration }}
								</div>

								<div (click)="changeState(subProgram)"
									class="full_screen_icon"><img
										src="../../../../../assets/images/inspect_icon.png"
										alt="">
								</div>
							</div>

							<h2 class="hire_inspire">{{subProgram.name}}</h2>
							<span class="programname">{{subProgram?.name}}</span>
							<p class="card_para_container">
								{{subProgram.description}}
							</p>


							<!-- <button class="letsGoBtn"
								*ngIf="!subProgram.isRegistered"
								(click)="onClickRegister(subProgram.id)">Register
								Interest</button>
							<button class="letsGoBtn interested"
								*ngIf="subProgram.isRegistered">Interested</button> -->

							<div class="card_footer">
								<div class="footer_column dNone">
									<div class="card_footerIcn">
										<img src="../../assets/images/Time Circle.svg"
											alt="">
									</div>
									<div class="card_footer_sub_head">
										{{ subProgram.courseTime | duration }}
									</div>
								</div>

								<div class="footer_column dNone">
									<div class="card_footerIcn">
										<img src="../../assets/images/Category.svg"
											alt="">
									</div>
									<div class="card_footer_sub_head">
										{{ getSectionNos(programSections) }}
										Sections
									</div>
								</div>

								<div class="footer_column">
									<div class="launchBtn">
										Launch <img style="margin-left: 4px"
											src="../../assets/images/Arrow - Right.svg"
											alt="">
									</div>
								</div>
							</div>
						</div>

					</div>
				</ng-container>

			</div>
		</div>
	</div>
</ng-template>

<div class="stuff-wrapper">
    <div class="stuff-overlay" *ngIf="state === 'open'" (click)="changeState('cross')" ></div>
    <div class="left-stuff" [@widthGrow]="state" *ngIf="programDetails">
        <div style="position: absolute;top: -40px;left: 50%;transform: translateX(-50%);z-index: 9999;" (click)="changeState('cross')" class="cross_btn_mobile"><img
                src="../../assets/images/sidenavcrossBtn.svg" alt=""></div>
        <div class="card_details_container">

            <div style="top: 20px;left: 20px;" (click)="changeState('cross')" class="cross_btn"><img src="../../assets/images/crossbtn.svg" alt=""></div>

            <div class="card_details">
                <div class="card_details_image">
                    <img class="inspectorImg"
                        [src]="programDetails?.landscapeImage ? programDetails?.landscapeImage : programDetails?.programImage  "
                        alt="">
                </div>
                <div class="card_container">
                    <div class="card_c_row">
                        <div *ngIf="programDetails.isUserEnrolled">
                            <div class="inprogress" style="background-color: #7675EA !important; color: white !important"
                                *ngIf="programDetails.progress === 100">
                                Completed
                            </div>
                            <div class="inprogress" *ngIf="programDetails.progress !== 100">
                                In Progress
                            </div>
                        </div>

                        <div *ngIf="!programDetails.isUserEnrolled">
                            <div class="noprogress">
                                Not Yet Started
                            </div>
                        </div>

                        <div class="hrs_section">
                            <!-- <span class="hours"><img src="../../assets/images/Time Circle.svg" alt="">
                                {{ getLearningHrs(programSections) }} Hours</span>
                            <span class="hours"><img src="../../assets/images/Time Circle.svg" alt="">
                                {{ programDetails.courseTime | duration }} Hours</span> -->
                            <span class="hours"><img src="../../assets/images/Time Circle.svg" alt="">
                                {{ programDetails.courseTime | duration }}</span>
                            <span class="section"><img src="../../assets/images/Category.svg" alt=""> {{
                                programDetails.numberOfSections ? programDetails.numberOfSections :
                                getSectionNos(programDetails.sections) }}


                                {{
                                programDetails.numberOfSections >= 2 ? 'Sections' :
                                'Section' }}

                            </span>
                        </div>
                    </div>
                    <h2 class="hire_inspire"
                        style="-webkit-line-clamp: unset !important; max-height: unset!important; height: unset!important">
                        {{programDetails.name}}</h2>
                    <p class="inspector-des">{{programDetails.description}}</p>
                </div>
                <div class="complete_launch_container">
                    <div class="complete progress" style="height: 10px">
                        <div class="complete_text">Complete {{ programDetails.progress ? programDetails.progress : 0 }}%
                        </div>
                        <div role="progressbar" class="progress-bar"
                            style.width="{{ programDetails.progress ? programDetails.progress : 0 }}%" aria-valuenow="10"
                            aria-valuemin="0" aria-valuemax="100">
                        </div>
                    </div>
                    <div class="launchBtn" (click)="launchProgramAfterCheck()">
                        Launch <img style="width: 18px;height: 18px; margin-left: 4px"
                            src="../../assets/images/Arrow - Right.svg" alt="Launch Button Image">
                    </div>


                </div>

                <div class="section_details_container">
                    <div class="section_detail_row" *ngFor="let section of programDetails?.sections">
                        <div class="sec_name_no">
                            <div class="section_name">{{ section.name }}</div> | <div class="total_units">{{
                                section.numberOfUnits ? section.numberOfUnits: 0 }}

                                {{
                                section.numberOfUnits >= 2 ? 'units' :
                                'unit' }}

                            </div>
                        </div>

                        <div class="section_desc" style="white-space: pre-line;">{{ section.description }}</div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>